import { FormattedMessage, useIntl } from "react-intl";
import { useEffect, useState } from "react";
import classes from "../../intro/pages/style.module.scss";
import StandardInstruction from "../../elements/text/standardInstruction.component.jsx";
import ToggleSetting from "../../elements/buttons/toggleSetting.component.jsx";

export default function Calendar(props) {
  const intl = useIntl();

  const [syncWithCalendar, setSyncWithCalendar] = useState(
    props.settings.syncWithCalendar
  );

  function handleSelectChange(event) {
    setCalendar(event.target.value);
  }

  const [calendar, setCalendar] = useState(props.settings.calendar);

  useEffect(() => {
    const settings = {
      calendar: {
        calendar,
        syncWithCalendar,
      },
    };
    props.setProperties(settings);
  }, [syncWithCalendar]);

  const settings = [
    {
      name: intl.formatMessage({
        id: "settings.calendar.syncWithCalendarTitle",
      }),
      text: intl.formatMessage({
        id: "settings.calendar.syncWithCalendarText",
      }),
      value: syncWithCalendar,
      set: setSyncWithCalendar,
    },
  ];

  const calendars = [
    {
      name: intl.formatMessage({
        id: "settings.calendar.privateCalendar",
      }),
      type: "private",
    },
    {
      name: intl.formatMessage({
        id: "settings.calendar.businessCalendar",
      }),
      type: "business",
    },
  ];

  return (
    <div className="d-flex flex-column">
      <StandardInstruction className={"mb-4"}>{props.text}</StandardInstruction>
      <div>
        {settings.map((s, index) => (
          <ToggleSetting
            key={index}
            onChange={() => s.set((prevState) => !prevState)}
            settingText={s.text}
            settingTitle={s.name}
            toggleValue={s.value}
          />
        ))}
      </div>
      <div>
        <h3>
          <FormattedMessage id="settings.calendar.selectCalendar" />
        </h3>
        <select
          className={classes.selectItem}
          onChange={handleSelectChange}
          value={calendar}
        >
          {calendars.map((c) => (
            <option value={c.type} key={c.type}>
              {c.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
